import { render, staticRenderFns } from "./AsActionWithCard.vue?vue&type=template&id=0b94f87e&scoped=true"
import script from "./AsActionWithCard.vue?vue&type=script&lang=js"
export * from "./AsActionWithCard.vue?vue&type=script&lang=js"
import style0 from "./AsActionWithCard.vue?vue&type=style&index=0&id=0b94f87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b94f87e",
  null
  
)

export default component.exports